import React from 'react';
import Footer from '../../components/Footer';
import LearnBody from './LearnBody';

const Learn = () => {
    return (
        <section>
            <LearnBody />
            <Footer />
        </section>
    );
};

export default Learn;